export const SALESPUBLIC_LOADING = "SALESPUBLIC_LOADING";
export const SALESPUBLIC_RESET = "SALESPUBLIC_RESET";
export const GET_SALESPUBLIC = "GET_SALESPUBLIC";
export const GET_SALESPUBLIC_ONE = "GET_SALESPUBLIC_ONE";
export const GET_SALESPUBLIC_SUCCESS = "GET_SALESPUBLIC_SUCCESS";
export const GET_SALESPUBLIC_FAIL = "GET_SALESPUBLIC_FAIL";
export const DELETE_SALESPUBLIC = "DELETE_SALESPUBLIC"
export const DELETE_SALESPUBLIC_SUCCESS = "DELETE_SALESPUBLIC_SUCCESS"
export const DELETE_SALESPUBLIC_FAIL = "DELETE_SALESPUBLIC_FAIL"
export const UPDATE_SALESPUBLIC = "UPDATE_SALESPUBLIC"
export const UPDATE_SALESPUBLIC_SUCCESS = "UPDATE_SALESPUBLIC_SUCCESS"
export const UPDATE_SALESPUBLIC_FAIL = "UPDATE_SALESPUBLIC_FAIL"
export const ADD_NEW_SALESPUBLIC = "ADD_NEW_SALESPUBLIC"
export const ADD_SALESPUBLIC_SUCCESS = "ADD_SALESPUBLIC_SUCCESS"
export const ADD_SALESPUBLIC_FAIL = "ADD_SALESPUBLIC_FAIL"